import { useState } from "react";

import iconPause from "../../assets/images/seekbar-pause.svg";
import iconPlay from "../../assets/images/seekbar-play.svg";
import { useGlobal } from "../../contexts/globalContext";
import { useHttpMethods } from "../../hooks/useHttpMethods";

export default function PlayPauseButton() {
  const { JANUS_REF, SCREEN_STATE, SET_SCREEN_STATE, SET_CURRENT_STREAM } = useGlobal();

  const { get } = useHttpMethods();

  // state as object, so it's easy to add another local state if necessary
  const [state, setState] = useState({
    isPlaying: true,
  });

  const switchScreenTo = (streamId, screenId, isChangeResMode) => {
    JANUS_REF.current.plugin.streaming.send({
      message: { request: "switch", id: streamId },
      success: () => console.log("✅ [janus switch] 🠊 success", streamId),
    });

    SET_CURRENT_STREAM(streamId);
    SET_SCREEN_STATE((p) => ({
      ...p,
      currentScreen: {
        ...p.currentScreen,
        id: screenId,
        state: "switching",
      },
      isChangeResMode,
    }));
  };

  const handleClick = () => {
    const screen = SCREEN_STATE.screens.find((x) => x.id === SCREEN_STATE.currentScreen.id);
    const rewindScreenId = screen.rewind_screen_id;

    rewindScreenId > 0 && switchScreenTo(rewindScreenId * 100 + 10, rewindScreenId, false);

    get(`https://gx143.lab.bgigs.com/update-play?command=${state.isPlaying ? "pause" : "play"}&screenId=1`);

    setState((p) => ({ ...p, isPlaying: !p.isPlaying }));
  };

  // useEffect(() => {
  //     socket.on('getStatus', data => {
  //         if (data === 'play') setState({ ...state, isPlaying: true });
  //         else if (data === 'pause') setState({ ...state, isPlaying: false });
  //     });
  // }, []);

  return (
    <button className="js__btn-play-pause flex btn-play-pause" type="button" onClick={handleClick}>
      <img src={state.isPlaying ? iconPause : iconPlay} alt="play" className={`btn-36 btn-seekbar-${state.isPlaying ? "pause" : "play"}`} />
    </button>
  );
}
